module.exports = __webpack_public_path__ + "static/media/ethereum-logo.35926b13.png";